/** @jsxRuntime classic */
/** @jsx jsxCustomEvent */
import jsxCustomEvent from '@micro-zoe/micro-app/polyfill/jsx-custom-event';
import { RootState } from '@/redux/store';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import microApp from '@micro-zoe/micro-app';
import ShadowSystemApi from '@/fetch/bussiness/shadow';
const ShadowSysView = () => {
  const login = useSelector((state: RootState) => state.login);
  const navigator = useNavigate();
  const requestApi = new ShadowSystemApi();
  const [inverseAddress, setInverseAddress] = useState({});
  const [newBootList, setNewBootList] = useState<any>([]);
  function pushState(path: string) {
    navigator(path);
  }
  useEffect(() => {
    microApp.setData('shadowSysApp', {
      login,
      pushState,
      inverseAddress,
      newBootList,
    });
  }, [login, pushState, inverseAddress, newBootList]);
  return (
    <micro-app
      name='shadowSysApp'
      url={process.env.JDX_APP_SHADOW_SYSTEM}
      baseroute='/app/shadowsystem'
      onDataChange={async (e: any) => {
        if (e.detail.data.latLonStr) {
          const temp_inverseAddress = await requestApi.getInverseAddress(
            e.detail.data.latLonStr,
          );
          setInverseAddress(temp_inverseAddress);
        } else if (e.detail.data.bootList) {
          const tempList: any = [];
          e.detail.data.bootList.forEach((item: any) => {
            requestApi.getInverseAddress(item.position).then((address) => {
              tempList.push({
                ...item,
                position: address?.formatted_addresses?.recommend,
              });
            });
          });
          setTimeout(() => {
            const res = tempList.toSorted(
              (a: any, b: any) =>
                new Date(a.nodeStartTime).getTime() -
                new Date(b.nodeStartTime).getTime(),
            );
            setNewBootList(res);
          }, 1000);
        }
      }}
    ></micro-app>
  );
};

export default React.memo(ShadowSysView);
